export const promisify = (cb: () => any, timeout = 1000) =>
  new Promise(resolve => setTimeout(() => resolve(cb()), timeout));
